// Identificadors de les estratègies de correcció i la seva classificació en
// dos passos:
//   - GENERALS  (pas 1): s'apliquen a tots els camps, sense dependre de l'àlies.
//   - DE CAMP   (pas 2): s'apliquen només a camps que encaixin amb un rol
//                        concret (per àlies), i sobre les dades ja passades pel
//                        pas general.
//
// Aquest mòdul no importa res per poder ser consumit tant pel nucli
// (`core/transform/pipeline.js`) com pels fitxers de config
// (`config/processors/*`) sense crear cicles d'importació.

export const STRATEGIES = Object.freeze({
  WHITESPACE: 'whitespace',
  PROPER_CASE: 'properCase',
  DATE: 'date',
  DOMAIN: 'closestDomain',
  RELOCATE: 'relocate',
});

// Estratègies de camp concret → rol vinculat. BUIT: les correccions lligades a un
// camp concret ara són programes del model (pas 7), no estratègies del pas 6.
// Tota estratègia es considera general.
export const FIELD_STRATEGY_ROLES = Object.freeze({});

export function isFieldStrategy(id) {
  return Object.prototype.hasOwnProperty.call(FIELD_STRATEGY_ROLES, id);
}

export function isGenericStrategy(id) {
  return !isFieldStrategy(id);
}

// Pas (scope) al qual pertany una proposta segons la seva estratègia.
export function scopeForStrategy(id) {
  return isFieldStrategy(id) ? 'field' : 'generic';
}
